import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: { flex: 1, minWidth: 0, color: theme.palette.text.primary },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    gap: 20, marginBottom: 24,
    [theme.breakpoints.down('md')]: { flexDirection: 'column', gap: 16 },
  },
  subtitle: { marginTop: 8, color: theme.palette.text.secondary, fontSize: 13 },
  filters: {
    display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: { width: '100%', '& > *': { flex: 1 } },
  },
  dates: {
    display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-start', marginBottom: 20,
    '& .MuiTextField-root': { minWidth: 170 },
    [theme.breakpoints.down('sm')]: { '& .MuiTextField-root': { width: '100%' } },
  },
  panel: {
    border: '1px solid #DADCE0', borderRadius: 10, overflow: 'hidden', marginBottom: 20,
  },
  overview: {
    display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
    gap: 24, padding: 24, background: '#F5F8F9', borderBottom: '1px solid #DADCE0',
    [theme.breakpoints.down('sm')]: { flexDirection: 'column', gap: 16, padding: 18 },
  },
  eyebrow: { fontSize: 12, color: theme.palette.text.secondary, marginBottom: 8 },
  amount: { fontSize: 30, fontWeight: 600, fontVariantNumeric: 'tabular-nums', lineHeight: 1.3 },
  count: { fontSize: 12, color: theme.palette.text.secondary, marginTop: 4 },
  table: {
    minWidth: 580,
    '& th': { background: '#F7F8FA', fontWeight: 600, verticalAlign: 'top' },
    '& th, & td': { padding: '16px 20px', borderBottom: '1px solid #EAECF0' },
    '& tbody tr:hover': { background: '#FAFBFC' },
    '& tfoot th, & tfoot td': { background: '#F0F4F6', fontWeight: 600, borderBottom: 0 },
  },
  cellAmount: { fontSize: 14, fontWeight: 500, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
  partial: { fontSize: 12, marginTop: 4, color: '#86551A', whiteSpace: 'normal' },
  periodTime: { display: 'block', fontSize: 11, fontWeight: 400, marginTop: 5, whiteSpace: 'nowrap' },
  tableNote: { padding: '14px 20px', fontSize: 12, color: theme.palette.text.secondary },
  scope: {
    fontSize: 12, color: theme.palette.text.secondary, lineHeight: 1.8,
    '& p': { margin: '0 0 8px' },
  },
  state: { padding: '36px 24px', '& h2': { fontSize: 20, marginBottom: 10 } },
  warning: { marginBottom: 20 },
}));
